import { render } from "./AudioTrack.vue?vue&type=template&id=3355968a&scoped=true"
import script from "./AudioTrack.vue?vue&type=script&lang=js"
export * from "./AudioTrack.vue?vue&type=script&lang=js"

import "./AudioTrack.vue?vue&type=style&index=0&id=3355968a&scoped=true&lang=css"

import exportComponent from "/home/richard/Code/CHE/project/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3355968a"]])

export default __exports__